import { SearchProvider } from "../search-provider"

export function ClassSearchProvider({
  children,
  url = "/search/gateway/classes/query",
}: React.PropsWithChildren<{ url?: string }>) {
  return (
    <SearchProvider
      source={[
        "class_details.name",
        "class_details.curriculum_key",
        "class_details.subject_key",
        "class_details.class_size_range",
        "class_details.speciality_attributes",
        "profile_details.name",
        "nested_live_classes.available_space",
        "id",
      ]}
      url={url}
    >
      {children}
    </SearchProvider>
  )
}
